<template>
  <div>
    <v-row>
      <v-col cols="2">
        <div>
          <v-btn :to="{name: 'services'}" color="blue" class="mb-2" block>Lista usług</v-btn>
          <div>
            <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
            </v-menu>
          </div>
          <div>
            <v-text-field v-model="filters.code" label="Numer rezeracji / ID"></v-text-field>
          </div>
          <div>
            <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
            </v-menu>
          </div>
          <div>
            <v-text-field v-model="filters.city" label="Miasto"></v-text-field>
          </div>
          <div>
            <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
            </v-menu>
          </div>
          <div>
            <v-text-field v-model="filters.surname" label="Nazwisko"></v-text-field>
          </div>
          <div>
            <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
            </v-menu>
          </div>
          <div>
            <v-menu
                v-model="menu9"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-select
                    :items="companies"
                    v-model="filters.company"
                    label="Firma"
                    item-value="id"
                    solo
                    v-bind="attrs"
                    v-on="on"
                    class="wastemaster-input-elevation"
                >
                  <template v-slot:selection="data">
                    {{ data.item.name }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }}
                  </template>
                </v-select>
              </template>
            </v-menu>
          </div>
          <div>
            <v-text-field v-model="filters.phone" label="Telefon" prepend-icon="mdi-phone"></v-text-field>
          </div>
          <div>
            <v-checkbox
                v-model="filters.hasReferralCode"
                label="Posiada kod polecający"
                hide-details
                class="mt-0"
            ></v-checkbox>
          </div>
          <div>
            <v-text-field v-model="filters.referralCode" label="Kod polecający"></v-text-field>
          </div>
          <div>
            <v-text-field v-model="filters.sourcePage" label="Źródło (strona zapytania)"></v-text-field>
          </div>
          <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="filters.dateFrom"
                  label="Od daty stworzenia"
                  prepend-icon="mdi-calendar-blank"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="filters.dateFrom"
                :first-day-of-week="1"
                @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
          <v-btn @click="filters.dateFrom = null" small color="secondary" class="mb-2" block>Wyczyść datę</v-btn>
        </div>
        <div>
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="filters.dateTo"
                  label="Do daty stworzenia"
                  prepend-icon="mdi-calendar-blank"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="filters.dateTo"
                :first-day-of-week="1"
                @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-btn @click="filters.dateTo = null" small color="secondary" class="mb-2" block>Wyczyść datę</v-btn>
        </div>
        <div>
          <v-menu
              v-model="menu20"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="filters.startDateFrom"
                  label="Data wynajmu od"
                  prepend-icon="mdi-calendar-blank"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="filters.startDateFrom"
                :first-day-of-week="1"
                @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-btn @click="filters.startDateFrom = null" small color="secondary" class="mb-2" block>Wyczyść datę</v-btn>
        </div>
        <div>
          <v-menu
              v-model="menu21"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="filters.startDateTo"
                  label="Data wynajmu do"
                  prepend-icon="mdi-calendar-blank"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="filters.startDateTo"
                :first-day-of-week="1"
                @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-btn @click="filters.startDateTo = null" small color="secondary" class="mb-2" block>Wyczyść datę</v-btn>
        </div>
        <div>
          <v-menu
              v-model="menu4"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-select
                  :items="supervisors"
                  v-model="filters.supervisor"
                  label="Opiekun"
                  item-value="id"
                  solo
                  v-bind="attrs"
                  v-on="on"
                  class="wastemaster-input-elevation"
              >
                <template v-slot:selection="data">
                  {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                </template>
              </v-select>
            </template>
          </v-menu>
        </div>
        <div>
          <v-menu
              v-model="menu4"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
          </v-menu>
        </div>
        <div>
          <v-chip-group v-model="filters.status" column active-class="primary--text" multiple>
            <v-chip v-for="(key, status) in statuses" :key="status" :value="status">
              {{ getStatusText(status) }} ({{ getStat(status) }})
            </v-chip>
          </v-chip-group>
        </div>
        <v-btn @click="getOrders();" color="primary" block>Filtruj</v-btn>
      </v-col>
      <v-col cols="10">
        <v-row class="mt-0 pt-0">
          <v-col cols="3" class="mt-0 pt-0">
            <v-btn @click="exportOrders" color="green" class="mb-2" block>Eksportuj</v-btn>
          </v-col>
        </v-row>
        <data-table
            ref="table"
            :headers="headers"
            :items="orders"
            :options.sync="options"
            :server-items-length="totalOrders"
            :loading="loading"
            class="elevation-1 row-pointer"
            @click:row="(order) => $router.push({name: 'order-details', params: { id: order.id }}).catch(()=>{})"
        >
          <template v-slot:item.id="{ item }">
            {{ item.uniqueId }} ({{ item.id }})
          </template>
          <template v-slot:item.supervisor="{ item }">
                        <span v-if="item.supervisor"
                              :style="'padding: 0.5rem; display:block; background:' + item.supervisor.color">
                          {{ item.supervisor.name }} {{ item.supervisor.surname }} ({{ item.supervisor.email }})
                        </span>
            <span v-else>
                          -
                        </span>
          </template>

          <template v-slot:item.status="{ item }">
            {{ getStatusText(item.status) }}
          </template>
          <template v-slot:item.user="{ item }">
            <router-link :to="{name: 'user-details', params: { id: item.user.id }}">
              {{ item.additionalDataRaw.name }} {{ item.additionalDataRaw.surname }} ({{ item.user.email }})
              <br>
              {{ item.additionalDataRaw.phone }}
            </router-link>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ localDateTime(item.createdAtDto) }}
          </template>
          <template v-slot:item.startAt="{ item }">
            {{ item.additionalDataRaw.dateFrom }}
          </template>
          <template v-slot:item.city="{ item }">
            {{ item.additionalDataRaw.city }}
          </template>
          <template v-slot:item.company="{ item }">
            {{ item.service.company.name }}
          </template>
          <template v-slot:item.value="{ item }">
            {{
              parseFloat((item.price + parseFloat(item.withInsurance ? item.insurancePrice : 0)) * item.additionalDataRaw.quantity).toFixed(2)
            }} zł
            <span v-if="item.withInsurance"> z ubezpieczeniem ({{ item.insurancePrice }} dzień netto) </span>
          </template>
          <template v-slot:item.referralCode="{ item }">
            {{ item.referralCode || '-' }}
          </template>
          <template v-slot:item.sourcePageTitle="{ item }">
            {{ item.sourcePageTitle || '-' }}
          </template>
        </data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../services/api';
import DataTable from "@/components/data-table/DataTable";
import formatters from '@/mixins/formatters';
import {getDatatableParams, setDatatableOptions, setDatatableFilters} from '@/utils/helpers';
import {OrderStatus, getStatusText} from '@/enums/OrderStatus';
import moment from 'moment';
import permissions from '@/mixins/permissions';
import debounce from "debounce";

export default {
  mixins: [
    formatters,
    permissions,
  ],
  components: {
    DataTable,
  },
  data() {
    return {
      statuses: OrderStatus,
      modal: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu9: false,
      menu20: false,
      menu21: false,
      filters: {
        dateFrom: this.getDateFrom().format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        startDateFrom: moment().format('YYYY-MM-DD'),
        startDateTo: moment().format('YYYY-MM-DD'),
        phone: null,
        supervisor: null,
        status: null,
        hasReferralCode: false,
        referralCode: null,
        sourcePage: null,
      },
      totalOrders: 0,
      orders: [],
      loading: true,
      options: {},
      headers: [
        {text: 'Numer rezerwacji (ID)', value: 'id', sortable: false},
        {text: 'Klient', value: 'user', sortable: false},
        {text: 'Miasto', value: 'city', sortable: false},
        {text: 'Wypożyczalnia', value: 'company', sortable: false},
        {text: 'Status', value: 'status', sortable: false,},
        {text: 'Utworzono', value: 'createdAt', sortable: false},
        {text: 'Data startu', value: 'startAt', sortable: false},
        {text: 'Wartość', value: 'value', sortable: false},
        {text: 'Kod polecający', value: 'referralCode', sortable: false},
        {text: 'Źródło', value: 'sourcePageTitle', sortable: false},
      ],
      reactOnFilterChange: true,
      supervisorFilter: null,
      stats: [],
      supervisors: [],
      companies: [],
    }
  },
  watch: {
    options: {
      handler() {
        this.getOrders();
      },
      deep: true,
    },
    filters: {
      handler() {
        if (!this.reactOnFilterChange) {
          return;
        }

        setDatatableFilters.call(this);
      },
      deep: true
    },

    supervisorFilter() {
      this.getOrdersFilteredBySupervisor();
    },
  },
  methods: {
    getDateFrom() {
      if (this.isAdmin()) {
        return moment().clone().subtract(3, 'months');
      }

      return moment().clone().subtract(2, 'weeks');
    },
    async getOrders() {
      this.loading = true;

      const {page, itemsPerPage} = this.options;

      if (this.filters.dateFrom) {
        const dateFromString = String(this.filters.dateFrom).substr(0, 10);
        this.reactOnFilterChange = false;

        if (!moment(dateFromString).isValid()) {
          this.filters.dateFrom = this.getDateFrom();
        } else {
          this.filters.dateFrom = dateFromString;
        }

        this.reactOnFilterChange = true;
      }

      let filters = this.filters

      if (filters.phone) {
        filters.phone = filters.phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/, '$1 $2 $3');
      }

      const params = {
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
        ...this.filters
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      if (!params.status) {
        delete params.status;
      }

      if (!params.hasReferralCode) {
        delete params.hasReferralCode;
      }

      if (!params.referralCode) {
        delete params.referralCode;
      }

      if (!params.sourcePage) {
        delete params.sourcePage;
      }

      const response = await api.get('/api/orders', {params});
      this.loading = false;

      this.orders = response.data.items;
      this.totalOrders = response.data.total;
      this.reactOnFilterChange = false;
      this.filters.dateFrom = response.data.dateFrom;

      setDatatableOptions.call(this);

      setTimeout(() => {
        this.reactOnFilterChange = true;
      }, 1000); // Delay the change a bit to avoid performing another query.
    },
    async exportOrders() {
      this.loading = true;

      if (this.filters.dateFrom) {
        const dateFromString = String(this.filters.dateFrom).substr(0, 10);
        this.reactOnFilterChange = false;

        if (!moment(dateFromString).isValid()) {
          this.filters.dateFrom = this.getDateFrom();
        } else {
          this.filters.dateFrom = dateFromString;
        }

        this.reactOnFilterChange = true;
      }

      let filters = this.filters

      if (filters.phone) {
        filters.phone = filters.phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/, '$1 $2 $3');
      }

      const params = {
        ...this.filters
      };

      if (!params.status) {
        delete params.status;
      }

      if (!params.hasReferralCode) {
        delete params.hasReferralCode;
      }

      if (!params.referralCode) {
        delete params.referralCode;
      }

      if (!params.sourcePage) {
        delete params.sourcePage;
      }

      const response = await api.get('/api/orders/export', {params});
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const date = new Date();
      const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

      link.setAttribute('download', formattedDate + '.csv');
      document.body.appendChild(link);
      link.click();
      this.loading = false;
    },
    async getStats() {
      const response = await api.get('/api/orders/stats');
      for (const [key, value] of Object.entries(response.data)) {
        this.stats[key] = value;
      }
    },
    getStatusText(status) {
      return getStatusText(status);
    },
    getStat(status) {
      return this.stats[status];
    },
    async getSupervisors() {
      this.loading = true;

      const response = await api.get('/api/users?role=ROLE_SUPERVISOR', {});
      this.loading = false;

      this.supervisors = [{id: 0, email: "Wybierz opiekuna"}].concat(response.data.items)
    },
    async getCompanies() {
      this.loading = true;

      const response = await api.get('/api/price-list/company?rental=true', {});
      this.loading = false;

      this.companies = [{id: 0, name: "Wybierz firmę"}].concat(response.data.items)
    },
  },
  created() {
    this.getSupervisors();
    this.getCompanies();
    getDatatableParams.call(this);
    for (const [key] of Object.entries(this.statuses)) {
      this.stats[key] = 0;
    }
    this.getStats();
    this.getOrdersFilteredBySupervisor = debounce(function () {
      this.getOrders();
    }, 500);
  }
}
</script>

<style lang="css" scoped>
.row-pointer >>> td {
  height: auto !important;
  padding: 0.5rem !important;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-chip {
  white-space: break-spaces !important;
  line-height: 14px;
  width: 100%;
  padding: 9px;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  overflow: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>